// extracted by mini-css-extract-plugin
export default {"favorites":"style_favorites__CcMi1","favorites__list_wrapper":"style_favorites__list_wrapper__EdZbe","favorites__types":"style_favorites__types__+dSFg","card":"style_card__BbSi3"};